module.exports = __webpack_public_path__ + "static/media/sc-6.f5df54da.png";